/* import __COLOCATED_TEMPLATE__ from './table-editor.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _class2, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
let TableControlPoints = (_class = class TableControlPoints {
  constructor(composer, activeTable, composerElement) {
    _defineProperty(this, "composer", void 0);
    _defineProperty(this, "composerElement", void 0);
    _defineProperty(this, "tbodyDomNode", void 0);
    _defineProperty(this, "tableDomNode", void 0);
    _defineProperty(this, "tableBorderWidth", 0);
    _defineProperty(this, "tableOffset", void 0);
    _initializerDefineProperty(this, "rowControlPoints", _descriptor, this);
    _initializerDefineProperty(this, "columnControlPoints", _descriptor2, this);
    _initializerDefineProperty(this, "fullTableControlPoint", _descriptor3, this);
    this.composer = composer;
    this.composerElement = composerElement;
    this.tbodyDomNode = this.composer.findDomAtDocumentPosition(activeTable.start).node;
    if (!this.tbodyDomNode.parentElement) {
      throw new Error('Parent table DOM element not found');
    }
    this.tableDomNode = this.tbodyDomNode.parentElement;
    this.tableOffset = this.computeOffset(this.tableDomNode);
    this.computeTableBorderWidth();
    this.updateFullTableControlPoint();
    this.updateRows();
    this.updateColumns();
  }
  computeTableBorderWidth() {
    let computedStyle = getComputedStyle(this.tableDomNode);
    let borderWidthString = computedStyle.getPropertyValue('border-left-width').replace('px', '');
    this.tableBorderWidth = Number.parseInt(borderWidthString, 10);
  }
  updateFullTableControlPoint() {
    let table = this.tableDomNode;
    let rect = table.getBoundingClientRect();
    rect.x = this.tableOffset.left;
    rect.y = this.tableOffset.top;
    this.fullTableControlPoint = {
      index: 0,
      clientRect: rect,
      isTableStart: false,
      isTableEnd: false
    };
  }
  computeOffset(element) {
    // when the composer is iframed, element will be null when the body of the iframed document has been reached
    // when not iframed, method will first reach the composer element
    if (!element || element === this.composerElement) {
      return {
        top: 0,
        left: 0
      };
    }
    let parentOffset = this.computeOffset(element.offsetParent);
    return {
      top: element.offsetTop + parentOffset.top,
      left: element.offsetLeft + parentOffset.left
    };
  }
  updateRows() {
    let tableBoundingRect = this.tableDomNode.getBoundingClientRect();
    let numberOfRows = this.tbodyDomNode.childElementCount;
    let rowDomNodes = Array.from(this.tbodyDomNode.children);
    this.rowControlPoints = rowDomNodes.map((row, index) => {
      let isTableStart = index === 0;
      let isTableEnd = index === numberOfRows - 1;
      let rowElement = row;
      let clientRect = rowElement.getBoundingClientRect();
      clientRect.x = this.tableOffset.left + rowElement.offsetLeft;
      clientRect.y = this.tableOffset.top + rowElement.offsetTop;
      let x = clientRect.x;
      let y = isTableStart ? clientRect.y : clientRect.y + this.tableBorderWidth;
      let width = tableBoundingRect.width;
      let height = isTableStart ? clientRect.height + 2 * this.tableBorderWidth : clientRect.height + this.tableBorderWidth;
      return {
        index,
        clientRect: new DOMRect(x, y, width, height),
        isTableStart,
        isTableEnd
      };
    });
  }
  updateColumns() {
    let rowDomNodes = Array.from(this.tbodyDomNode.children);
    let tableBoundingRect = this.tableDomNode.getBoundingClientRect();
    let firstRowCells = Array.from(rowDomNodes[0].children);
    let numberOfColumns = firstRowCells.length;
    this.columnControlPoints = firstRowCells.map((firstCell, index) => {
      let isTableStart = index === 0;
      let isTableEnd = index === numberOfColumns - 1;
      let firstCellBoundingRect = firstCell.getBoundingClientRect();
      let firstCellElement = firstCell;
      firstCellBoundingRect.x = firstCellElement.offsetLeft + this.tableOffset.left;
      firstCellBoundingRect.y = firstCellElement.offsetTop + this.tableOffset.top;
      let x = isTableStart ? firstCellBoundingRect.x : firstCellBoundingRect.x + this.tableBorderWidth;
      let y = this.tableOffset.top;
      let width = isTableStart ? firstCellBoundingRect.width + 2 * this.tableBorderWidth : firstCellBoundingRect.width + this.tableBorderWidth;
      let height = tableBoundingRect.height;
      return {
        index,
        clientRect: new DOMRect(x, y, width, height),
        isTableStart,
        isTableEnd
      };
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "rowControlPoints", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "columnControlPoints", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "fullTableControlPoint", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
})), _class);
let TableEditor = (_class2 = class TableEditor extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "tableControlPoints", _descriptor4, this);
  }
  get composer() {
    return this.args.composer;
  }
  get state() {
    return this.args.composer.state;
  }
  get isVisible() {
    return this.state.selectionIsInTable && !this.state.selectionIsInContainer || this.state.selectionIsLayout;
  }
  get showColumnAndRowControl() {
    return !this.args.composer.state.selectionIsLayout;
  }
  get isAddingEnabled() {
    let maxColumns = this.args.options?.maxColumns;
    if (!maxColumns) {
      return true;
    }
    let numberOfColumns = this.tableControlPoints?.columnControlPoints.length;
    return numberOfColumns && numberOfColumns < maxColumns;
  }
  updateTableControlPoints() {
    let activeTable;
    if (this.state.selectionIsLayout) {
      activeTable = this.state.selectedLayout;
    } else {
      activeTable = this.composer.state.currentlyActiveTable;
    }
    if (!activeTable) {
      return;
    }
    this.tableControlPoints = new TableControlPoints(this.composer, activeTable, this.args.composerElement);
  }
}, (_descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "tableControlPoints", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "updateTableControlPoints", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "updateTableControlPoints"), _class2.prototype)), _class2);
export { TableEditor as default };